import React from 'react';
import { createTheme } from "@material-ui/core/styles";
import {
    Typography,
    Box,
    Paper,
    TextField,
    Button
} from '@material-ui/core';

//css
import SectionCss from './Section-css';
const useStyles = SectionCss();

const theme = createTheme({
    overrides: {
        MuiInputLabel: { // Name of the component ⚛️ / style sheet
            root: { // Name of the rule
                color: "rgb(118, 118, 118)",
                "&$focused": { // increase the specificity for the pseudo class
                    color: "#159B78"
                }
            }
        }
    }
});

export default function Section(props) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={'container'} style={{maxWidth:700}}>

                <Box component="span" m={1}>
                    <Paper className={classes.root}>
                        <div className={classes.boxForm}>
                            <Typography variant="h5" component="h3" className={classes.title}>
                                {props.state.tipo} {props.props.route.title}
                            </Typography>
                            <form className={classes.container} noValidate autoComplete="off">
                                <TextField variant={"filled"}
                                    id="standard-name"
                                    label="Descrição"
                                    className={classes.textField}
                                    InputProps={{
                                        className: classes.multilineColor
                                    }}
                                    margin="normal"
                                    onChange={(e)=>{props.setState({descricao:e.target.value})}}
                                    value={props.state.descricao}
                                />
                                <div className={classes.buttonAction} align="right">
                                    <Button className={classes.buttonCancelar} onClick={()=>{props.props.router.goBack()}}>
                                        {'Cancelar'}
                                    </Button>
                                    <Button variant="contained" color="primary" onClick={()=>{props.validacao()}}>
                                        {'Salvar'}
                                    </Button>
                                </div>
                                <br/>
                            </form>
                        </div>
                    </Paper>
                </Box>

            </div>
        </div>
    );
}